const triggerSelector = ".news__share-trigger";
const modalSelector = ".share__modal";
const closeSelector = ".share__modal-close";
const titleSelector = ".share__modal-title, [data-share-modal-title]";
const shareSelectors = {
  email: ".news__share-btn--email, [data-share='email']",
  linkedin: ".news__share-btn--linkedin, [data-share='linkedin']",
  facebook: ".news__share-btn--facebook, [data-share='facebook']",
  x: ".news__share-btn--x, [data-share='x']"
};

let initialized = false;

export function initShareModal() {
  if (initialized) return;

  const modal = document.querySelector(modalSelector);
  const triggers = document.querySelectorAll(triggerSelector);

  if (!modal || triggers.length === 0) return;

  initialized = true;
  setupShareLinks(modal);
  bindOpenTriggers(modal, triggers);
  bindCloseTriggers(modal);
}

function bindOpenTriggers(modal, triggers) {
  triggers.forEach(function(trigger) {
    trigger.addEventListener("click", function(event) {
      event.preventDefault();
      openModal(modal);
    });
  });
}

function bindCloseTriggers(modal) {
  modal.querySelectorAll(closeSelector).forEach(function(closeButton) {
    closeButton.addEventListener("click", function(event) {
      event.preventDefault();
      closeModal(modal);
    });
  });

  document.addEventListener("keydown", function(event) {
    if (event.key === "Escape" && modal.classList.contains("open")) {
      closeModal(modal);
    }
  });
}

function setupShareLinks(modal) {
  const shareData = getShareData();
  const titleElement = modal.querySelector(titleSelector);

  if (titleElement) {
    titleElement.textContent = "Share this article";
  }

  Object.keys(shareSelectors).forEach(function(type) {
    modal.querySelectorAll(shareSelectors[type]).forEach(function(element) {
      setupShareButton(element, type, shareData);
    });
  });
}

function setupShareButton(element, type, shareData) {
  const shareUrl = getShareUrl(type, shareData);
  const link = element.matches("a") ? element : element.querySelector("a");

  element.setAttribute("role", "button");
  element.setAttribute("tabindex", "0");

  if (link) {
    link.setAttribute("href", shareUrl);
    link.setAttribute("target", type === "email" ? "_self" : "_blank");
    link.setAttribute("rel", "noopener noreferrer");
  }

  element.addEventListener("click", function(event) {
    event.preventDefault();
    openShareUrl(type, shareUrl);
  });

  element.addEventListener("keydown", function(event) {
    if (event.key !== "Enter" && event.key !== " ") return;

    event.preventDefault();
    openShareUrl(type, shareUrl);
  });
}

function openShareUrl(type, shareUrl) {
  if (type === "email") {
    window.location.href = shareUrl;
    return;
  }

  window.open(shareUrl, "_blank", "noopener,noreferrer,width=640,height=640");
}

function openModal(modal) {
  modal.classList.add("open");
  modal.setAttribute("aria-hidden", "false");
}

function closeModal(modal) {
  modal.classList.remove("open");
  modal.setAttribute("aria-hidden", "true");
}

function getShareData() {
  const title = getArticleTitle();
  const url = getCanonicalUrl();

  return {
    title: title,
    url: url,
    encodedTitle: encodeURIComponent(title),
    encodedUrl: encodeURIComponent(url)
  };
}

function getArticleTitle() {
  const heading = document.querySelector("h1");

  if (heading && heading.textContent.trim()) {
    return heading.textContent.trim();
  }

  return document.title.replace(/\s*\|\s*Abraham Trading\s*$/, "").trim();
}

function getCanonicalUrl() {
  const canonical = document.querySelector("link[rel='canonical']");
  const href = canonical && canonical.getAttribute("href");

  return href || window.location.href.split("#")[0];
}

function getShareUrl(type, shareData) {
  if (type === "email") {
    return "mailto:?subject=" + shareData.encodedTitle +
      "&body=" + encodeURIComponent(shareData.title + "\n\n" + shareData.url);
  }

  if (type === "linkedin") {
    return "https://www.linkedin.com/sharing/share-offsite/?url=" + shareData.encodedUrl;
  }

  if (type === "facebook") {
    return "https://www.facebook.com/sharer/sharer.php?u=" + shareData.encodedUrl;
  }

  return "https://twitter.com/intent/tweet?text=" + shareData.encodedTitle +
    "&url=" + shareData.encodedUrl;
}
